function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.936,
    height: 19.116,
    viewBox: "0 0 17.936 19.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25984"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24847",
    d: "M12612 321v9.872l8.848-4.158-.218-9.905z",
    transform: "translate(-12603.033 -312.182)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23730"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23729"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23799",
    d: "M33.512 4.151 24.97.027a.276.276 0 0 0-.24 0l-8.542 4.124a.276.276 0 0 0-.156.248v10.015a.276.276 0 0 0 .156.248l8.542 4.124a.276.276 0 0 0 .24 0l8.542-4.124a.276.276 0 0 0 .156-.248V4.4a.276.276 0 0 0-.156-.249zM24.85.581 32.758 4.4l-2.292 1.106a.273.273 0 0 0-.047-.029l-7.855-3.793zM21.942 2l7.9 3.812-1.617.781-7.897-3.815zm8.082 4.335v2.882l-1.511.729V7.06zm3.093 7.91L25.125 18.1V8.7l1.906-.92a.276.276 0 1 0-.24-.5l-1.942.938-.764-.369a.276.276 0 1 0-.24.5l.728.352v9.4l-7.991-3.858v-9.4l6.085 2.938a.276.276 0 0 0 .24-.5L16.942 4.4l2.738-1.322 8.279 4v3.307a.276.276 0 0 0 .4.248l2.062-1a.276.276 0 0 0 .156-.248v-3.32l2.542-1.227z",
    transform: "translate(-15.882 .154)",
    style: {
      stroke: "#393939",
      strokeWidth: ".3px",
      fill: "#393939"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23732"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23731"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23800",
    d: "m49.7 341.894-1.254-.605a.276.276 0 1 0-.24.5l1.254.605a.276.276 0 0 0 .24-.5z",
    transform: "translate(-46.722 -328.627)",
    style: {
      fill: "#393939"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23734"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23733"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23801",
    d: "m50.9 306.879-2.406-1.161a.276.276 0 1 0-.24.5l2.406 1.161a.276.276 0 1 0 .24-.5z",
    transform: "translate(-46.768 -294.363)",
    style: {
      fill: "#393939"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.ff9085136960acbe0bfe88a8a190a51a.svg";
export { ForwardRef as ReactComponent };